import { PropsWithChildren } from 'react';

import styles from './modal.module.css';

type ModalContentProps = PropsWithChildren<{
  variant?: 'default' | 'two-columns';
}>;

export const ModalContent = ({ children, variant = 'default' }: ModalContentProps) => (
  <div data-variant={variant} className={styles.content}>
    {children}
  </div>
);
